module.exports = __webpack_public_path__ + "img/ic_contact.d36b5ab3.svg";